import { AllUsersTable } from '../../components/AllUsersTable';

function AllUsersTablePage() {
  return <AllUsersTable />;
}

export default AllUsersTablePage;
